import { useCanAccess } from "@/hooks/useCanAccess"
import usePrimaryMenu from "./usePrimaryMenu";
import { ChatRoom } from "@/types/chat";
import { NavLink } from "react-router-dom";
import { classNames } from "@/utils";
import { secondaryMenu } from "./menu";
import { LinkIcon } from "@heroicons/react/24/outline";
import Badge from "@/components/Badge";

interface Props {
    pendingChats: ChatRoom[];
}
const MobileNavbar = ({ pendingChats }: Props) => {
    const canAccess = useCanAccess()
    const mainMenu = usePrimaryMenu({ pendingChatCount: pendingChats.length })

    return (
        <nav className="px-2 space-y-1">
            {mainMenu.map(
                (item) =>
                    canAccess(item) && (
                            <NavLink
                                key={item.name}
                                to={item.href}
                                className={({ isActive }) =>
                                    classNames(
                                        isActive
                                            ? "bg-primary-800 text-white"
                                            : "text-primary-100 hover:bg-primary-600",
                                        "group flex items-center px-2 py-2 text-base font-medium rounded-md"
                                    )
                                }
                            >
                                <item.icon
                                    className="mr-4 flex-shrink-0 h-6 w-6 text-primary-300"
                                    aria-hidden="true"
                                />
                                <span className="relative">
                                    {item.name}
                                    {(item.name.toLowerCase() === 'chat' && item.count) ? <Badge className="left-12">{item.count}</Badge> : null}
                                </span>
                            </NavLink>
                        )
                )}
            {secondaryMenu.map(
                (menu, index) => (
                        <div className="flex flex-row px-2 p-2" key={index}>
                            <LinkIcon className=" flex-shrink-0 h-6 w-6 text-primary-300" />
                            <details className="open:bg-primary-700 duration-300">
                                <summary className="px-3 text-md cursor-pointer text-primary-100 list-none font-medium">
                                    {menu.name}
                                </summary>
                                <div className="flex flex-col">
                                    {menu.subMenu.map(
                                        (item: any) =>
                                canAccess(item) && (
                                                <NavLink
                                                    key={item?.name}
                                                    to={item?.href}
                                                    className={({ isActive }) =>
                                                        classNames(
                                                            isActive
                                                                ? "bg-primary-800 text-white"
                                                                : "text-primary-100 hover:bg-primary-600",
                                                            "group flex items-center py-2 text-base font-medium rounded-md w-full"
                                                        )
                                                    }
                                                >
                                                    <item.icon
                                                        className="mr-3 flex-shrink-0 h-6 w-6 text-primary-300"
                                                        aria-hidden="true"
                                                    />
                                                    {item.name}
                                                </NavLink>
                                            )
                                    )}
                                </div>
                            </details>
                        </div>
                    )
            )}
        </nav>
    )
}

export default MobileNavbar;
